import styled from 'styled-components';

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Title = styled.div`
  margin-bottom: 8px;
`;
